<template>
  <div class="vz-cargo-dimension-view">
    <div class="vz-cargo-dimension-view-type">
      <div v-if="cargoMark" class="mr-20">
        <vz-icon name="check" variant="primary" class="mr-10" />
        <span>Груз</span>
      </div>
      <div v-if="correspondenceMark">
        <vz-icon name="check" variant="primary" class="mr-10" />
        <span>Корреспонденция</span>
      </div>
    </div>
    <div class="vz-cargo-dimension-view-general vz-cargo-view-item">
      <div class="vz-cargo-view-item-title">
        Общие габариты
      </div>
      <div class="vz-cargo-view-item-list">
        <div>
          Объем:
          <span class="vz-cargo-view-item-value">{{ generalVolume }} м3</span>
        </div>
        <div>
          Вес:
          <span class="vz-cargo-view-item-value">{{ generalWeight }} кг</span>
        </div>
        <div>
          Мест:
          <span class="vz-cargo-view-item-value">{{ generalPlace }} шт</span>
        </div>
      </div>
    </div>
    <div class="vz-cargo-dimension-view-mode">
      <vz-cargo-dimension-view-item
        v-if="isDimensionMode"
        title="Максимальные габариты одного места"
        :dimension="order.cargo.dimensions.detail"
      />
      <template v-else>
        <vz-cargo-dimension-view-item
          v-for="(item, i) in modeItems"
          :key="i"
          :dimension="item"
          :title="`${modeTitle} ${i + 1}`"
        />
      </template>
    </div>
  </div>
</template>

<script setup lang="ts">
import VzCargoDimensionViewItem from './vz-cargo-dimension-view-item.vue'
import {OrderCargoMods, OrderForm, OrderPallet, OrderParcel, OrderPlace} from '~/types/types';
import {PropType} from 'vue';
import VzIcon from '~/components/ui-kit/vz-icon.vue';

const props = defineProps({
  order: {
    type: Object as PropType<OrderForm>,
    default: () => ({})
  }
})

const mode = computed( (): OrderCargoMods => {
  return props.order.cargo.mode
})

const isDimensionMode = computed( (): boolean => {
  return mode.value === 'dimension'
})

const generalVolume = computed( (): number => {
  return props.order?.cargo?.dimensions?.general?.volume
})

const generalWeight = computed( (): number => {
  return props.order?.cargo?.dimensions?.general?.weight
})

const generalPlace = computed( (): number => {
  return props.order?.cargo?.dimensions?.general?.place
})

const modeItems = computed( (): OrderPlace[] | OrderParcel[] | OrderPallet[] => {
  switch (mode.value) {
    case 'parcels':
      return props.order.cargo.parcels.items
    case 'pallets':
      return props.order.cargo.pallets.items
    default:
      return props.order.cargo.places.items
  }
})

const modeTitle = computed( (): string => {
  switch (mode.value) {
    case 'parcels':
      return 'Посылка'
    case 'pallets':
      return 'Паллета'
    default:
      return 'Груз'
  }
})

const cargoMark = computed( (): boolean => {
  return props.order.cargo.type.cargo
})

const correspondenceMark = computed( (): boolean => {
  return props.order.cargo.type.correspondence
})
</script>
